import React, { Component } from 'react';
import { connect } from 'react-redux';
import defaultOptions from '@object-generators/wood-connection/defaultOptions';
import Input from '@components/Input';
import { APP_TYPES, defaultUnits } from '@config';
import { APP_TEXTS } from '@texts';
import './styles.scss';
import { setNailOptions } from '@reducers/options/nail/actions';
import { unitTransform } from '@services/helper.service';


class HolesConfiguration extends Component {

  handleDiameterChange = (value) => {
    const newOptions = {
      ...this.props.nailsConfiguration,
      diameter: unitTransform(Number(value), false).from(this.props.distanceUnit).to(defaultUnits.DISTANCE)
    };
    this.props.setNailOptions(newOptions);
  };

  handleConfigurationChange = (field, value) => {
    const newOptions = {
      ...this.props.nailsConfiguration,
      [field]: Number(value)
    };
    this.props.setNailOptions(newOptions);
  };

  handleSpacingChange = (field, value) => {
    const newOptions = {
      ...this.props.nailsConfiguration,
      spacings: {
        ...this.props.holesConfig.spacings,
        [field]: unitTransform(Number(value), false).from(this.props.distanceUnit).to(defaultUnits.DISTANCE)
      }
    };

    this.props.setNailOptions(newOptions);
  };

  handleScChange = (value) => {
    const newOptions = {
      ...this.props.nailsConfiguration,
      spacings: {
        ...this.props.nailsConfiguration.spacings,
        sc: unitTransform(Number(value), false).from(this.props.distanceUnit).to(defaultUnits.DISTANCE)
      }
    };
    this.props.setNailOptions(newOptions);
  };

  handleInputChange = (field, value) => {
    const newOptions = {
      ...this.props.nailsConfiguration,
      spacings: {
        ...this.props.nailsConfiguration.spacings,
        [field]: unitTransform(parseFloat(value), false).from(this.props.distanceUnit).to(defaultUnits.DISTANCE)
      }
    };
    this.props.setNailOptions(newOptions);
  };

  render() {
    const { diameter, n, p, spacings } = this.props.nailsConfiguration;
    return (
      <div className="holes-container list-type">
        <div className="d-flex align-items-center">
          <div>
            <Input
              id="diameter"
              type="number"
              value={unitTransform(diameter).from(defaultUnits.DISTANCE).to(this.props.distanceUnit)}
              onUpdate={this.handleDiameterChange}
              prefix={
                <span className="prefix-label">
                  {APP_TEXTS.WOOD_CONNECTION_HOLE_DIAMETER.Content}
                </span>
              }
              postfix={this.props.distanceUnit}
            />
          </div>
          <div className="ml-3">
            <Input
              id="spacing-sc"
              type="number"
              value={unitTransform(spacings.sc).from(defaultUnits.DISTANCE).to(this.props.distanceUnit)}
              onUpdate={this.handleScChange}
              prefix={
                <span className="prefix-label">
                  {APP_TEXTS.WOOD_CONNECTION_HOLE_SPACING_SC.Content}
                </span>
              }
              postfix={this.props.distanceUnit}
            />
          </div>
        </div>
        <div className="spacing-row np-inputs">
          <span className="np-label">{APP_TEXTS.WOOD_CONNECTION_SPACING_NP.Content}</span>
          <Input
            id="config-n"
            type="number"
            value={n}
            onUpdate={(value) => this.handleConfigurationChange('n', value)}
            maxValue={5}
          />
          <Input
            id="config-p"
            type="number"
            value={p}
            onUpdate={(value) => this.handleConfigurationChange('p', value)}
          />
        </div>
        <div className="s-inputs">
          {[...Array(n)].map((_, index) => (
            <Input
              key={`spacing-S${index + 1}`}
              id={`spacing-S${index + 1}`}
              type="number"
              value={
                unitTransform(spacings[`s${index + 1}`] || defaultOptions.spacing.vertical.s)
                  .from(defaultUnits.DISTANCE).to(this.props.distanceUnit)
              }
              onUpdate={(value) => this.handleInputChange(`s${index + 1}`, value)}
              prefix={`${APP_TEXTS.WOOD_CONNECTION_SPACING_S1.Content.replace('1', index + 1)} = `}
              postfix={this.props.distanceUnit}
            />
          ))}
        </div>
        <div className="c-inputs">
          {[...Array(n)].map((_, index) => (
            <Input
              key={`spacing-C${index + 1}top`}
              id={`spacing-C${index + 1}top`}
              type="number"
              value={
                unitTransform(spacings[`c${index + 1}Top`] || defaultOptions.spacing.vertical.c)
                  .from(defaultUnits.DISTANCE).to(this.props.distanceUnit)
              }
              onUpdate={(value) => this.handleInputChange(`c${index + 1}Top`, value)}
              prefix={`${APP_TEXTS.WOOD_CONNECTION_SPACING_C1TOP.Content.replace('1', index + 1)} = `}
              postfix={this.props.distanceUnit}
            />
          ))}
        </div>
      </div>
    );
  }

}

const mapStateToProps = (state) => ({
  nailsConfiguration: state.dimension[APP_TYPES.WOOD_CONNECTION].nailsConfiguration,
  distanceUnit: state.main.units.distance
});

export default connect(mapStateToProps, { setNailOptions })(HolesConfiguration);



// WEBPACK FOOTER //
// ./src/views/Dimension/components/HolesConfiguration/HolesConfiguration.js